//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { default as commonModule, LoggerService } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { UserSession, ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { SERVICES_MODULE_NAME } from './../../services'
import { GRID_CONTEXT_MENU_SERVICE_NAME, GridContextMenuService } from '../../services/grid'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../services/user-session'
import { PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'

import { AlarmDetailsDirective } from './details/alarms-details.directive'
import { AlarmController, AlarmsScope } from './alarms.controller'

import { AlarmHelper } from './alarms.helper'

//#region Asset Imports

import * as TEMPLATE from './alarms.tpl.html'

//#endregion


// Consts

const CONTROLLER_NAME: string = 'AlarmsController'
const DETAILS_DIRECTIVE_NAME: string = 'alarmDetails'
const MENU_INDEX = 9
const MODULE_NAME: string = 'simax.alarms'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'ALARM_NAME'
const STATE_NAME: string = 'alarms'
const STATE_URL: string = '/alarms'


// Consts End


// Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new AlarmDetailsDirective()])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    GRID_CONTEXT_MENU_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope: AlarmsScope,
        $state: StateService,
        $timeout,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        gridContextMenuService: GridContextMenuService,
        userSession: UserSessionService,
        systemService: SystemService
    ) => new AlarmController(
        $scope,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        gridContextMenuService,
        userSession,
        systemService,
        AlarmHelper.REFERENCE_TYPE,
        AlarmHelper.SIMAX_MODULE_NAME
    )])

module.config(["$stateProvider", 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider

) => {
    systemServiceProvider.registerDetailsComponent({
        key: 'Alarm_IdAlarmEvent',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.ALARM_EVENT_LIST)
                && !loggedOperator.hasPermission(Activity.ALARM_EVENT_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.AlarmEventModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.ALARMS),
                    'alarms',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End


export default MODULE_NAME